import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const cashJourneyRoutes = [
  {
    id: 'cash-out',
    trackingName: 'Cash Out',
    path: 'dl/view/cash-out',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashOut')).JourneyCashOut,
    }),
  },
  {
    id: 'cash-out-amount',
    trackingName: 'Cash Out Amount',
    path: 'dl/view/cash-out/:cents_amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashOutAmount')).JourneyCashOutAmount,
    }),
  },
  {
    id: 'add-cash',
    trackingName: 'Add Cash',
    path: 'dl/view/add-cash',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCash')).JourneyAddCash,
    }),
  },
  {
    id: 'add-cash-amount',
    trackingName: 'Add Cash Amount',
    path: 'dl/view/add-cash/:cents_amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCashAmount')).JourneyAddCashAmount,
    }),
  },
] as const satisfies JourneyRoute[]
